import MainNavigation from './navigation/MainNavigation';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
axios.defaults.baseURL = 'https://backend.aivimart.com/public/api/';
// axios.defaults.baseURL = 'http://127.0.0.1:8000/api';
export const SHIPROCKET_PASS = 'wzPkMPq9#$i^$1eULJiz4khRRt5ldzAQ';

function App() {
  return (
    <div className="App">
      <MainNavigation />
    </div>
  );
}

export default App;
